module.exports = __webpack_public_path__ + "static/nitra-cc2be50ab5d52910b5d33fb7b6c22bea.jpg";